/**
 * Text Hero: image box reveal between words (same principle as home-hero video).
 * On load, the title "splits" and the image fades in. Only runs if .text-hero__image-wrap exists.
 */
import gsap from "gsap";

function getWrapWidthEnd(wrap) {
	const value = getComputedStyle(wrap).getPropertyValue("--text-hero-image-width").trim();
	const parsed = parseFloat(value, 10);
	return Number.isFinite(parsed) ? parsed : 146;
}

export function initTextHeroImage() {
	const wrap = document.querySelector(".text-hero__image-wrap");
	if (!wrap) return;

	const box = wrap.querySelector(".text-hero__image-box");
	if (!box) return;

	const tl = gsap.timeline({ defaults: { ease: "power2.out" }, delay: 1 });
	tl.to(wrap, { width: getWrapWidthEnd(wrap), duration: 0.5 });
	tl.to(box, { opacity: 1, duration: 0.35 }, "-=0.2");
}
